import { render, staticRenderFns } from "./EditApprovalList.vue?vue&type=template&id=f5e38d9c"
import script from "./EditApprovalList.vue?vue&type=script&lang=js"
export * from "./EditApprovalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports